
export default function LegislativeAdviceResults({searchTerm, searchResults, total = null , limit}) {
  return (
    <>
      <div className={"search-results__wrapper"}>
        {searchResults.length > 0 &&
          <ul className="search-results__list">
            {searchResults.slice(0, limit).map((result, index) =>
              <li className={"search-result search-result--" + result.type.system} key={index}>
                <article className={"search-result__content"}>
                  <h4 className={"search-result__heading"}>
                    <a className={'search-result__link'} href={result.link}>{result.title}</a>
                  </h4>
                  <div className="search-result__meta">
                    <p className={"label label--small"}>
                      <span>Wetgevingsadvies</span>
                      <span className="page-meta__divider">&bull;</span>
                      <time dateTime={result.dates.created.iso}>{result.dates.created.formatted}</time>
                    </p>
                  </div>
                </article>
              </li>
            )}
          </ul>
        }
      </div>
    </>
  );
}
